/** Routes excluded from commercial analytics (central list). */
export const ANALYTICS_EXCLUDED_PATH_PREFIXES: readonly string[] = [
  '/admin-panel',
];

export const ANALYTICS_SESSION_STORAGE_KEY = 'sb-analytics-session';
export const ANALYTICS_VISITOR_STORAGE_KEY = 'sb-analytics-visitor-id';
export const ANALYTICS_SEQUENCE_KEY = 'sb-analytics-sequence';

/** Inactivity timeout before starting a new session (ms). */
export const ANALYTICS_SESSION_INACTIVITY_MS = 30 * 60 * 1000;

/** Heartbeat interval while the tab is visible (ms). */
export const ANALYTICS_HEARTBEAT_MS = 15_000;

/** Max engaged time credited per heartbeat tick (ms). */
export const ANALYTICS_HEARTBEAT_CAP_MS = ANALYTICS_HEARTBEAT_MS + 2_000;

/** Matches API slugified controller route (`AnalyticsEvents` → `analytics-events`). */
export const ANALYTICS_INGEST_URL = '/api/analytics-events/batch';
